export const getPartner = (affiliateCode: string): string | null => {
  return affiliateCode.split('-')[1] || null;
};
